import { NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WyswigEditorComponent } from '@shared/libraries/wyswig/components/wyswig-editor/wyswig-editor.component';
import { NgxEditorModule } from 'ngx-editor';

@NgModule({
    declarations: [
        WyswigEditorComponent
    ],
    exports: [
        WyswigEditorComponent
    ],
    imports: [
        NgxEditorModule.forRoot({
            locals: {
                /** Menu */
                bold: 'Pogrubienie',
                italic: 'Pochylenie',
                code: 'Kod',
                underline: 'Podkreślenie',
                strike: 'Przekreślenie',
                blockquote: 'Cytat',
                bullet_list: 'Lista nieuporządkowana',
                ordered_list: 'Lista uporządkowana',
                heading: 'Nagłówek',
                h1: 'Nagłówek 1',
                h2: 'Nagłówek 2',
                h3: 'Nagłówek 3',
                h4: 'Nagłówek 4',
                h5: 'Nagłówek 5',
                h6: 'Nagłówek 6',
                align_left: 'Wyrównaj do lewej',
                align_center: 'Wyrównaj do środka',
                align_right: 'Wyrównaj do prawej',
                align_justify: 'Wyjustuj',
                text_color: 'Kolor tekstu',
                background_color: 'Kolor tła',
                horizontal_rule: 'Pozioma linia',
                format_clear: 'Wyczyść formatowanie',
                insertLink: 'Wstaw link',
                removeLink: 'Usuń link',
                insertImage: 'Wsaw obraz',
                indent: 'Zwiększ wcięcie',
                outdent: 'Zmniejsz wcięcie',
                superscript: 'Indeks górny',
                subscript: 'Indeks dolny',
                undo: 'Cofnij',
                redo: 'Ponów',

                /** Inne */
                url: 'Adres URL',
                text: 'Tekst',
                openInNewTab: 'Otwórz w nowej karcie',
                insert: 'Wstaw',
                altText: 'Tekst alternatywny',
                title: 'Tytuł',
                remove: 'Usuń',
                enterValidUrl: 'Wprowadź poprawny adres URL',
            },
        }),
        FormsModule,
        ReactiveFormsModule,
        NgIf,
    ]
})
export class WyswigModule {
}
